import { apiRequest } from './client';

export interface Partner {
  id: string;
  name: string;
  type: string | null;
  description: string | null;
  logoUrl: string | null;
  websiteUrl: string | null;
  visible: boolean;
  sortOrder: number;
}

export type PublicPartner = Pick<Partner, 'id' | 'name' | 'type' | 'description' | 'logoUrl' | 'websiteUrl'>;

export interface PartnerInput {
  name: string;
  type: string;
  description?: string | null;
  logoUrl?: string | null;
  websiteUrl?: string | null;
  visible?: boolean;
}

export const fetchPublicPartners = (): Promise<{ items: PublicPartner[]; types: Record<string, string> }> => apiRequest('/public/partners');
export const fetchPartners = (): Promise<{ items: Partner[]; types: Record<string, string> }> => apiRequest('/partners');
export const createPartner = (input: PartnerInput): Promise<Partner> => apiRequest<Partner>('/partners', { method: 'POST', body: input });
export const updatePartner = (id: string, input: Partial<PartnerInput>): Promise<Partner> => apiRequest<Partner>(`/partners/${id}`, { method: 'PATCH', body: input });
export const deletePartner = (id: string): Promise<void> => apiRequest<void>(`/partners/${id}`, { method: 'DELETE' });
export const reorderPartners = async (ids: string[]): Promise<Partner[]> => (await apiRequest<{ items: Partner[] }>('/partners/reorder', { method: 'POST', body: { ids } })).items;
